export const DOCUMENT_DESIGN_SECTION = {
  PAGE_NUMBER_LABEL: { key: 'PAGE_NUMBER_LABEL', value: 'Page {{PageNum}} of' },
  MOVE_PAGE_UP_TOOLTIP: { key: 'MOVE_PAGE_UP_TOOLTIP', value: 'Move up' },
  MOVE_PAGE_DOWN_TOOLTIP: { key: 'MOVE_PAGE_DOWN_TOOLTIP', value: 'Move down' },
  DUPLICATE_PAGE_TOOLTIP: { key: 'DUPLICATE_PAGE', value: 'Duplicate page' },
  DELETE_A_PAGE_TOOLTIP: { key: 'DELETE_A_PAGE_TOOLTIP', value: 'Delete page' },
  ADD_PAGE_LABEL: { key: 'ADD_PAGE_LABEL', value: 'Add page' },
  ADD_NEW_PAGE_TOOLTIP: { key: 'ADD_NEW_PAGE_TOOLTIP', value: 'Add new page' },
  PAGE_EMPTY_PLACEHOLDER: { key: 'PAGE_EMPTY_PLACEHOLDER', value: 'Drag & drop elements here' },
  PAGE_BACKGROUND_COLOR_TOOLTIP: {
    key: 'PAGE_BACKGROUND_COLOR_TOOLTIP',
    value: 'Background color',
  },
  REARRANGE_PAGES_TOOLTIP: {
    key: 'REARRANGE_PAGES_TOOLTIP',
    value: 'Rearrange Pages',
  },
  REARRANGE_PAGES_MODAL_TITLE: {
    key: 'REARRANGE_PAGES_MODAL_TITLE',
    value: 'Rearrange Pages',
  },
  SAVE_REARRANGED_CHANGES_BUTTON: {
    key: 'SAVE_REARRANGED_CHANGES_BUTTON',
    value: 'Save changes',
  },
  CANCEL_REARRANGE_PAGE_BUTTON: {
    key: 'CANCEL_REARRANGE_PAGE_BUTTON',
    value: 'Cancel',
  },
  EDIT_TEMPLATE_NAME_TOOLTIP: {
    key: 'EDIT_TEMPLATE_NAME_TOOLTIP',
    value: 'Edit Template Name',
  },
  TEMPLATE_NAME_PLACEHOLDER: {
    key: 'TEMPLATE_NAME_PLACEHOLDER',
    value: 'Name your template',
  },
  REFERENCED_ELEMENT_LABEL: {
    key: 'REFERENCED_ELEMENT_LABEL',
    value: 'Referenced',
  },
  EDIT_REFERENCED_ELEMENT_TOOLTIP: {
    key: 'EDIT_REFERENCED_ELEMENT_TOOLTIP',
    value: 'Edit referenced element',
  },
  CLOSE_SIDEBAR_SETTINGS_PANEL_TOOLTIP: {
    key: 'CLOSE_SIDEBAR_SETTINGS_PANEL_TOOLTIP',
    value: 'Close settings',
  },
  CLOSE_SIDEBAR_LAYOUT_PANEL_TOOLTIP: {
    key: 'CLOSE_SIDEBAR_LAYOUT_PANEL_TOOLTIP',
    value: 'Close layout panel',
  },
  SHOW_SIDEBAR_LAYOUT_PANEL_TOOLTIP: {
    key: 'SHOW_SIDEBAR_LAYOUT_PANEL_TOOLTIP',
    value: 'Show layout panel',
  },
  CLOSE_SIDEBAR_FONT_PANEL_TOOLTIP: {
    key: 'CLOSE_SIDEBAR_FONT_PANEL_TOOLTIP',
    value: 'Close font panel',
  },
  AI_AUTO_FILL_CONTENT_MODAL_INFO: {
    key: 'AI_AUTO_FILL_CONTENT_MODAL_INFO',
    value: 'Let us do the copy writing for you. Sit back and relax!!!',
  },
  AI_TEXT_GENERATE_FREE_PLAN_LIMIT_EXCEEDED_MESSAGE: {
    key: 'AI_TEXT_GENERATE_FREE_PLAN_LIMIT_EXCEEDED_MESSAGE',
    value: 'Your current plan lacks the capability to generate text due to its limited features. To access this feature, you can upgrade your plan'
  },
  AI_TEXT_GENERATE_PREMIUM_PLAN_LIMIT_EXCEEDED_MESSAGE: {
    key: 'AI_TEXT_GENERATE_PREMIUM_PLAN_LIMIT_EXCEEDED_MESSAGE',
    value: "You've reached the text generation limit under your current plan. You can opt to wait until the next month when your limit resets, or you have the option to explore upgrading your plan"
  },
  CELL_OPTIONS_POPOVER_TITLE: {
    key: 'CELL_OPTIONS_POPOVER_TITLE',
    value: 'Cell options',
  },
  GROUP_ELEMENT_TOOLTIP: {
    key: 'GROUP_ELEMENT_TOOLTIP',
    value: 'Group',
  },
};

export const UPDATE_DATE_VARIABLE_FORMAT_POPUP = {
  DATE_FORMAT_LABEL: { key: 'DATE_FORMAT_LABEL', value: 'Date format' },
  CANCEL_UPDATE_DATE_FORMAT_BUTTON: { key: 'CANCEL_UPDATE_DATE_FORMAT_BUTTON', value: 'Cancel' },
  SAVE_DATE_FORMAT_BUTTON: { key: 'SAVE_DATE_FORMAT_BUTTON', value: 'Save' },
};
